module.exports = __webpack_public_path__ + "img/home_news_5.81f2a602.png";